import React from 'react';
import { Button } from 'antd';
import { LeftOutlined } from '@ant-design/icons';

const BackButton = ({ onConfirm }) => {
  return (
    <Button
      icon={<LeftOutlined style={{ fontSize: '18px', color: '#006939' }} />}
      onClick={onConfirm}
      type="link" 
      shape="circle" 
      style={{
        padding: 0, 
        border: 'none', 
        textAlign: 'left', 
        marginLeft: 0,
      }}
    />
  );
};

export default BackButton;